import React from "react";
import Imgix from "react-imgix";
import { ButtonBackEvents } from "../Buttons";
import CTABlock from "../CTABlock";
import { endSlash } from "../../util/helperFunctions";

const TopTierBannerCheers = ({ page, year }) => {
  const yearFridayCheers = year;

  return (
    <div className="banner--page relative flex flex-column justify-end w-100">
      <div className="banner--page__image h-100 w-100 bg-grey1">
        {page.bannerImage && (
          <Imgix
            src={endSlash(page.bannerImage.url)}
            className="bg-center image-cover mb0 h-100 w-100"
            imgixParams={{
              "max-w": 2732,
              "max-h": 600,
              "fp-x": page.bannerImageFocalPointX,
              "fp-y": page.bannerImageFocalPointY,
              auto: ["compress"],
              fit: "crop",
              crop: "focalpoint"
            }}
            htmlAttributes={{
              alt: page.bannerImageAltText
            }}
          />
        )}
      </div>
      <div className="banner--page__title--wrapper w-100 flex-l flex-column items-center">
        <div className="w-100 mw-1060 relative">
          <ButtonBackEvents />
          <div className="banner--page__title bg-stone">
            <h1 className="h-2 h-1--l dark mb1 mb2-l">{page.title}</h1>
            <h2 className="h-5 ttu dark mw-530">{page.subtitle}</h2>
          </div>
          {yearFridayCheers ?
            <CTABlock
              heading={`${year} Season Lineup`}
              altText="Friday Cheers Lineup Banner Image"
              img="https://mortycms.imgix.net/store/d2073e4ec7d005096b2a7516e4ea2d2f.png?ixlib=react-8.5.1&auto=compress&fit=crop&fp-x=0.43417&fp-y=0.02&crop=focalpoint&w=798"
              ctas={[
                {
                  url: `/our-events/friday-cheers-${year}/lineup/`,
                  text: "View Lineup"
                },
                {
                  url: "https://www.myticketstobuy.com/events?venue=18",
                  text: "Buy Tickets"
                }
              ]}
            />
          :
           <CTABlock
              heading="2025 Season Lineup"
              altText="Friday Cheers Lineup Banner Image"
              img="https://mortycms.imgix.net/store/d2073e4ec7d005096b2a7516e4ea2d2f.png?ixlib=react-8.5.1&auto=compress&fit=crop&fp-x=0.43417&fp-y=0.02&crop=focalpoint&w=798"
              ctas={[
                {
                  url: `/our-events/friday-cheers-2025/lineup/`,
                  text: "View Lineup"
                },
                {
                  url: "https://www.myticketstobuy.com/events?venue=18",
                  text: "Buy Tickets"
                }
              ]}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default TopTierBannerCheers;



// WEBPACK FOOTER //
// ./src/components/Banners/TopTierBannerCheers.js